/**
 * Plant Selector FILTERS
 */
import { App } from './desertland.app';
import { Service } from './desertland.service';
import { Utils } from './cals.utils';
import { ROUTES } from './desertland.router';
import 'kendo-ui-core';
// import 'kendo-ui-core/js/kendo.layout';
// import 'kendo-ui-core/js/kendo.data';
import 'kendo-ui-core/js/kendo.dropdownlist';
import 'kendo-ui-core/js/kendo.pager';
import 'kendo-ui-core/js/kendo.mobile.drawer';
import 'kendo-ui-core/js/kendo.listview';


/* tslint:disable variable-name prefer-for-of member-ordering */
declare var log, info, warn, groupCollapsed, groupEnd, time, timeEnd;


/*
    * http://docs.telerik.com/kendo-ui/api/javascript/data/datasource#methods-filter
    * http://docs.telerik.com/kendo-ui/api/javascript/data/datasource#configuration-filter
    * 
    filter: {
        // leave data items which are "Food" or "Tea"
        logic: "or",
        filters: [
            { field: "category", operator: "eq", value: "Food" },
            { field: "name", operator: "eq", value: "Tea" }
        ]
    }

Clear filters:
    datasource.filter([]); or .filter({})

Remove a filter:
    filters.filters.splice(i, 1);
    datasource.filter(filters);

Add a filter:
    filters.filters.push({ field: "Filter", operator: "eq", value: 1 });
    datasource.filter(filters);
    * 
    * filter.operator can be:
    *      "eq" (equal to), "neq" (not equal to), "lt" (less than), "lte" (less than or equal to), 
    *      "gt" (greater than), "gte" (greater than or equal to), 
    *      "startswith", "endswith", "contains". The last three are supported only for string fields.
    */
//DESERTLAND.Plants.datasource.filter( { field: "common_name", operator: "contains", value: "acacia" });


export class Plants {
  public showLogs = false;
  public page = ROUTES.PLANTS;
  public container = "#tmpl_main_content";
  public tplSel = 'tpl-layout-plant-selector';
  public subContainer = "#plant-selector-listview";
  public tplSelSub = 'tpl-plant-selector-list-item';

  public searchable = ['common_name', 'botanical_name'];

  public datasource: any; // need to call getDataSource() first

  public searchVal: string;

  public render = { 
    // rendering functions
  };

  private pager: any;
  private listView: any;

  public datasourceConfig = {
    offlineStorage: "plants-list-local",
    pageSize: (function () {
      let iRet = 12;
      if (!Utils.isEmpty(App.config) && !Utils.isEmpty(App.config.plants) && !Utils.isEmpty(App.config.plants.listPageSize) && App.config.plants.listPageSize > 0) {
        iRet = App.config.plants.listPageSize;
      } else {
        console.error("config.plants.pageSize not found - using default: ", iRet);
      }
      //log("getPageSize",iRet); 
      return iRet;
    })(),
    sort: { field: "common_name", dir: "asc" }, // default sort
    transport: {
      read: {
        // the remote service url
        url: "/" + Service.webServiceEndpoint + "plant.json",

        // the request type
        type: "get",

        // the data type of the returned result
        dataType: "json",

        // additional custom parameters sent to the remote service
        data: {}
      }
    },
    // describe the result format
    schema: {

      // model: Plant,
      schema: {
        model: { id: "nid" }
      },
      parse(data) {
        $.each(data, function (idx, elem) {
            // Extend original elem
            elem.common_name_url = Utils.changeSpacesToDashes(elem.common_name);
            elem.img_url_path = App.config.img_url.plant;
        });
        return data;
      },

      // // the data, which the data source will be bound to is in the "list" field of the response
      data(data) {
        // log('App.Plants.datasource : %o',data);
        if (data && data.length > 0) {
          App.data.plants = data;
          return data;
        }
        return [];
      }
    }
  };// end datasourceConfig

  // public filters = {
  public filtersDefaultLogic = "and"; //supported values are "and" and "or"

  public filtersCreate(logic?, filter?): any {
    let o: any = {};
    o.logic = logic || this.filtersDefaultLogic;
    o.filters = [];
    if (filter) {
      o.filters.push(filter);
    }
    return o;
  }

  public filtersGet() {
    let filter = this.datasource.filter();
    //log("get current filter:",filter);
    if (!filter || !filter.filters) {
      info("get filter - create new filters obj");
      filter = this.filtersCreate();
    }
    return filter;
  }
  
  public filtersGetIndexes(filter, field) {
    // look into sub-filters to find immediate children, 
    // return object  
    let itemIndex = -1,
      fieldIndex = -1;

    if (filter && filter.filters && field) {

      for (let i = 0; i < filter.filters.length; i++) {
        let filterSet = filter.filters[i];
        // info(filterSet);
        if (filterSet.filters) {
          itemIndex = this.filtersGetFieldFilterIndex(filterSet.filters, field);
          if (itemIndex >= 0) {
            fieldIndex = i;
            break;
          } else {
            itemIndex = -1;
          }
        }
      }

    } else {
      info("getINdexes parameter error", filter, field);
    }

    return {
      itemIndex,//: itemIndex, 
      fieldIndex//: fieldIndex
    };
  }

  public filtersGetFieldFilterIndex(filters, field) {
    // look into sub-filters to find immediate children
    //log("getFieldFilterIndex > ",field, filters);
    let iRet = -1;
    let map = filters.map(function (m) { return m.field; });
    // log('map',map);
    iRet = map.indexOf(field);
    // log("map.indexof '%s': %i %o", field, iRet, map);
    // return map.indexOf(field);
    // return filters.map(function(m) { return m.field; }).indexOf(field);
    return iRet;
  }

  public filtersAddSearch(search) {
    info("addSearch", search);
    if (search) {
      let op = "contains",
        logic = "and",
        filter = this.filtersGet(),
        searchFilt: {search?: boolean, filters?: any[]} = {},
        searchFiltInd = -1;

      // log("currrent filter", filter);

      //check for the search filter
      if (filter.filters) {

        searchFiltInd = filter.filters.map(function (x) { return x.search; }).indexOf(true);
        // let objectFound = filter.filters[searchFiltInd];
        //log('searchFiltInd', searchFiltInd);
        if (searchFiltInd < 0) {
          // create new
          searchFilt = this.filtersCreate("or");
          searchFilt.search = true; // identify it as the search filter
          searchFiltInd = filter.filters.length;//add it to the end
        } else {
          searchFilt = filter.filters[searchFiltInd];
        }
      }

      // log(`searchFilt i=${searchFiltInd} searchFilt, searchable`,searchFilt, this.searchable);

      this.searchable.forEach((field) => {

        // searchFilt.filters.push({ field, operator: op, value: search }); // TODO: what is this?
        searchFilt.filters.push({ field, operator: op, value: search });

      });

      filter.filters[searchFiltInd] = searchFilt;

      this.datasource.filter(filter);
      info("App.Plants.datasource.filters: %o", filter);

    }
  }

  public filtersAdd(field, operator, value, logic, bClearOtherFiltersForField) {

    if (field) {
      // The supported operators are: 
      //"eq" (equal to), "neq" (not equal to), "isnull" (is equal to null), "isnotnull" (is not equal to null), 
      //"lt" (less than), "lte" (less than or equal to), "gt" (greater than), "gte" (greater than or equal to), 
      //"startswith", "endswith", "contains", "Utils.isEmpty", "isnotempty". The last five are supported only for string fields.
      operator = operator || "contains";//(!Utils.isEmpty(operator) ? operator : "contains");//neq
      value = (!Utils.isEmpty(value) ? value : "");
      logic = (!Utils.isEmpty(logic) ? logic : this.filtersDefaultLogic);
      bClearOtherFiltersForField = (!Utils.isEmpty(bClearOtherFiltersForField) ? bClearOtherFiltersForField : false);

      if (bClearOtherFiltersForField) {
        this.filtersClear(field);//, logic); // remove any previous 
      }

      let filter = this.filtersGet();//App.Plants.datasource.filter();

      log('filter.add', field, typeof operator === "string" ? operator : "(function)", value, logic, filter);
      //info('filter.filters.length',filter.filters.length);

      // let itemIndex = -1,
      //     fieldIndex = -1;
      let { itemIndex, fieldIndex } = this.filtersGetIndexes(filter, field);

      //info("fieldIndex: %i itemIndex: %i",fieldIndex,itemIndex);

      if (fieldIndex >= 0) {
        if (filter.filters[fieldIndex].filters) {
          filter.filters[fieldIndex].filters.push({ field, operator, value });
        } else {
          console.error("where is the filter man?");
        }
      } else {
        //log('else create new', filter);
        filter.filters.push(this.filtersCreate(logic, { field, operator, value }));
      }

      // filters.push({ field: field, operator: operator, value: value });
      //filter = this.addFilter(filter, field, operator, value, logic);

      this.datasource.filter(filter);
      info("App.Plants.datasource.filters: %o", filter);
    } else {
      console.error("Field must be defined to add a filter.");
    }
  }

  public filtersRemove(field, value) {
    log("filters.remove", field, value);

    if (field) {

      if (field === "Search") {
        //info("this is a search term");
        this.clearSearch();
        App.plantSelectorForm.clearSearchInput();
      } else {
        let filter = this.filtersGet();//App.Plants.datasource.filter();

        //info('filter.remove', field, value);

        let { itemIndex, fieldIndex } = this.filtersGetIndexes(filter, field);
        //info("fieldIndex: %i itemIndex: %i", fieldIndex, itemIndex);

        if (fieldIndex >= 0) {
          if (filter.filters[fieldIndex].filters) {
            //loop and remove the item
            let filts = filter.filters[fieldIndex].filters;
            for (let i = filts.length - 1; i >= 0; i--) { // go backwards since you're splicing
              //info(filts[i]);
              if (filts[i].field === field && filts[i].value === value) {
                //log("removing", i , filts[i]);
                filts.splice(i, 1);
                //break;//dont break cuz we want to remove all matching - max loops will be like 6|8
              }
            }
            //log("filts",filts);

            if (filts.length === 0) {
              //info("// it's empty - remove the whole filters object",filter.filters[fieldIndex]);
              filter.filters.splice(fieldIndex, 1);
            }

            //log(filter);
            this.datasource.filter(filter);
          } else {
            console.error("where is the filter man?", field, value, filter);
          }
        } else {
          info('you tried to remove a filter not found', field, value, filter);
        }
      }
    } else {
      console.error("Field must be defined to remove a filter.");
    }
  }//end remove

  public filtersClear(field) {

    log('filters.clear', field);

    if (field) {

      let clearFun = (clearField, skipWarn?) => {
        let filter = this.filtersGet();//this.datasource.filter();
        // log("clearFun > clearField: %o filter: %o",clearField,filter);

        let { itemIndex, fieldIndex } = this.filtersGetIndexes(filter, clearField);
        // log("clearFun > fieldIndex: %i itemIndex: %i",fieldIndex,itemIndex);

        if (fieldIndex >= 0) {
          if (filter.filters[fieldIndex].filters) {
            // log("clearFun > remove the whole filters object for", clearField, filter.filters[fieldIndex]);
            filter.filters.splice(fieldIndex, 1);

            this.datasource.filter(filter);
            return true;
          } else {
            console.error("where is the filter man?");
          }
        } else {
          if (!skipWarn) {
            info('you tried to clear a filter not found', filter);
          }
          // console.error("hey, uh, your datasource is not refreshed...");// fixed with refactor 14 july 16
        }
        return false;
      };


      //log('handle special cases : filter.clear', field);
      //info("you now have the form json to loop thru: %o",App.data.PlantSelectorForm);
      let section = 'functions';
      switch (field) {
        case "growth_rate":
        /* falls through */
        case "soil":
        /* falls through */
        case "maintenance":
          // field = "maintenance";
          section = 'growing_requirements';
        /* falls through */
        case "ecological_role":
        /* falls through */
        case "ethnobotany":
          if (App.data.PlantSelectorForm
            && App.data.PlantSelectorForm.selector_filters
            && App.data.PlantSelectorForm.selector_filters[section]) {

            let o = App.data.PlantSelectorForm.selector_filters[section].find(function (el) {
              //log(el);
              for (let p in el) {
                //log(p);
                if (p === field) {
                  return true;
                }
              }
              return false;
            });

            if (o && o[field] && o[field].items) {
              // info(o[field]);
              // es6 allows break
              // for (let item of o[field].items) {
              //     log(item);
              //     if (item.value) {
              //         if (clearFun(item.value)) {
              //             info("found, break");
              //             break;
              //         }
              //         log("not found, continue",item.value);
              //     }
              // }
              // doesn't allow break when found, but we dont need that since we need to check all
              o[field].items.forEach(function (item) {
                //log(item);
                if (item.value) {
                  let clearSuccess = clearFun(item.value, true);
                  if (clearSuccess) {
                    log("found", item.value);
                    // } else {
                    //     log("not found", item.value);
                  }
                }
              }, this);
            } else {
              info("should have found items || !o[field]? field:", field, o);
            }


          } else {
            info("should have found something? field:", field);
          }
          break;

        default:

          clearFun(field);
        // v2 - before splitting out to function 
        // let {itemIndex, fieldIndex} = this.getIndexes(filter, field); 

        // info("fieldIndex: %i itemIndex: %i",fieldIndex,itemIndex);

        // if (fieldIndex >= 0) {
        //     if (filter.filters[fieldIndex].filters) {
        //         info("// remove the whole filters object",filter.filters[fieldIndex]);
        //         filter.filters.splice(fieldIndex, 1);

        //         this.datasource.filter(filter);
        //     } else {
        //         console.error("where is the filter man?");
        //     }
        // } else {
        //     info('you tried to clear a filter not found', filter);

        //     console.error("hey, uh, your datasource is not refreshed...");
        //     //this.datasource.filter({}); // reset to empty object
        // }
      }

    } else {
      console.error("Field must be defined to clear a filter.");
    }
  }//end clear

  public filtersReset() {
    this.datasource.filter({}); // reset to empty object

  }//end reset

  // };//end filters

  // public sort = { //App.plantList.sort.asc()
  public sortGet() {
    return this.datasource.sort();
  }
  public sortByCommon() {
    let oSort = this.sortGet();
    oSort[0].field = "common_name";
    this.datasource.sort(oSort);
  }
  public sortByBotanical() {
    let oSort = this.sortGet();
    oSort[0].field = "botanical_name";
    this.datasource.sort(oSort);
  }
  public sortAsc() {
    let oSort = this.sortGet();
    oSort[0].dir = "asc";
    this.datasource.sort(oSort);
  }
  public sortDesc() {
    let oSort = this.sortGet();
    oSort[0].dir = "desc";
    this.datasource.sort(oSort);
  }
  // };//end sort



  

  public init(options) {
    // time("App.Plants.init");
    groupCollapsed("Plants.init");
    log("plants.init options:", options);

    this.getDataSource();

    if (options && options.suffix) {
      this.searchVal = Utils.strDecodeURI(options.suffix);
    } else {
      this.searchVal = null;
    }

    //info (document.location) ;

    if (this.containerExists()) {
      this.getStarted();
    } else {
      info("create the layout");
      if ($(this.container).length) {
        log("ready for layout");
        this.loadTpl(this.renderTpl);
      } else {
        $(() => {
          log("plants dom ready!");
          if (typeof this.loadTpl === "function" && typeof this.renderTpl === "function") {
            this.loadTpl(this.renderTpl);
          } else {
            info("this issue?");
          }

        });
      }
    }
    groupEnd("Plants.init");
  }

  public getStarted() {
    info("Plants > GetStarted");

    this.initListKendoWidgets();

    App.plantSelectorForm.getThenRender();

    this.addEvents();

    if (this.searchVal) {
      this.setSearch(this.searchVal);
    }

    // timeEnd("App.Plants.init");
  }

  public loadTpl(callback) {
    log("Plants > loadTpl");
    if ($(this.tplSel).length) {
      log("// we already have the tpl");
      this.renderTpl({ sel: this.tplSel });
    } else {
      App.templates.loadLayout(this.page, this.tplSel, this.renderTpl);
    }

  }

  public renderTpl = (resp) => {
    $(document).ready(() => {
      groupCollapsed("Plants.Render");
      log("Plants > renderContent", resp);
      let sel = (resp && resp.sel) ? '#' + resp.sel : '#' + this.tplSel,
        subSel = '#' + this.tplSelSub;
  
      //log(sel);
      if ($(sel).length) {
  
        let layout = new kendo.Layout($(sel).html(), { model: App.models.pageView.viewModel });
        $(this.container).empty();
        layout.render($(this.container));

        // create the links
        kendo.bind($("#plants_biblio_link"), kendo.observable({
          link: "/#/" + ROUTES.BIBLIOGRAPHY
        }));
        kendo.bind($("#plants_contact_link"), kendo.observable({
          link: "/#/" + ROUTES.CONTACT
        }));
        kendo.bind($("#plants_learn_link"), kendo.observable({
          link: "/#/" + ROUTES.LEARN
        }));

  
        if ($(subSel).length && $(this.subContainer).length) {
          // var view = new kendo.View($(subSel).html());
          // info(view);
          // layout.showIn($(this.subContainer), view);
          this.getStarted();
        } else {
          log("App.Plants SUB container dne");
        }
  
      } else {
        info("no sel?");
      }
      groupEnd("Plants.Render");
    });
  }


  public containerExists() {
    if ($("#plant-selector-scroller").length && $("#plant-selector-listview").length) { //&& $("#plant-selector-listview-template").length) {
      return true;
    } else {
      log("App.Plants container dne");
      return false;
    }
  }
  // getPageSize : function () {
  //     var iRet = 12;
  //     if (!Utils.isEmpty(App.config) && !Utils.isEmpty(App.config.plants) && !Utils.isEmpty(App.config.plants.listPageSize) && App.config.plants.listPageSize > 0) {
  //         iRet = App.config.plants.listPageSize;
  //     } else {
  //         console.error("config.plants.pageSize not found - using default: ",iRet);
  //     }
  //     return iRet;
  // },




  public getNewDataSource(callback) {
    log("getNewDataSource");
    let ds = new kendo.data.DataSource(this.datasourceConfig);
    ds.fetch(function () {
      callback(this);//.data());
    });
  }

  public fetchDataThen(callback) {
    if (Utils.isEmpty(this.datasource)) {
      this.getDataSource();
    }
    this.datasource.fetch(function () {
      // var data = this.data();
      // console.log(data.length); 
      // console.log(data[0].ProductName);
      callback(this);//.data());
    });

    // this.datasource.read().then(function() {
    //     //var view = this.datasource.view();
    //     //console.log(view[0]);
    //     callback(this.datasource);
    // });

  }

  public getDataSource() {
    //info("get Plants Datasource");

    this.datasource = new kendo.data.DataSource(this.datasourceConfig);

    //return this.datasource;
  }

  public initListKendoWidgets() {

    if (this.containerExists()) {
      log("initListKendoWidgets");


      if ($("#plant-selector-pager").length) {
        this.pager = $("#plant-selector-pager").kendoPager({
          dataSource: this.datasource,
          //autoBind: false,
          pageSizes: [12, 24, 48, "all"], //true, 
          messages: {
            display: "Showing {0}-{1} of {2}",
            itemsPerPage: "Plants per page",
            empty: "No results were found.<br>Try removing some filters."
          }
        }).data("kendoPager");
      } else {
        log("NO #plant-selector-pager ??");
      }

      //$("#plant-selector-scroller").kendoMobileScroller();// weird ui - no use

      // info($("#" + this.tplSelSub).html());

      const subContainer = this.subContainer;

      this.listView = $("#plant-selector-listview").kendoListView({
        dataSource: this.datasource, 
        template: kendo.template($("#" + this.tplSelSub).html()),
        dataBound(e) {
          // log("plant-selector-listview onDataBound", e);
          // log("plant-selector-listview onDataBound", $(subContainer));// + " > li"));
          $(subContainer + " > li").addClass("col-sm-4");
        }
      }).data("kendoListView");
    } else {
      log("initKendoWidg container dne");
    }

  } //end initListKendoWidgets

  public destroyPager() {
    // if ($("#plant-selector-pager").length) {
    //     var pager = $("#plant-selector-pager").data("kendoPager");
    //     pager.destroy();
    // }
    if (this.pager && typeof this.pager.destroy === "function") {
      // log("destroyPager...");
      this.pager.destroy();
      this.pager = null;
    }
  }

  public setSearch(val) {
    //info("setSearch",val);
    // if (document.plants_search && document.plants_search.search_by_name) {
    if ($('#search_by_name').length) {
      //if($("#search_by_name").length) {
      $('#search_by_name').val(val.trim());
      // $("#search_by_name").val(val.trim());

      this.search(false);
      window.setTimeout(App.plantSelectorForm.toggleSearchClear, 1000);
    }
  }

  public search = (clearFirst: boolean = true) => {
    // if (document.plants_search && document.plants_search.search_by_name && document.plants_search.search_by_name.value) {
    if ($('#search_by_name').length && $('#search_by_name').val()) {
      let searchVal = $('#search_by_name').val().toString().trim();
      log("search: %s", searchVal);

      searchVal = String(searchVal).replace(/[`~!@#$%^&*()_|+\-=?;:",.<>\{\}\[\]\\\/]/gi, ''); //allowed apostrophe (')
      //log("cleaned search: %s", searchVal);

      if (searchVal) {
        if (clearFirst) {
          this.clearSearch(); // 2019 remove prior search first
        }

        this.filtersAddSearch(searchVal);

        let addToMulti = function () {
          let item = 'Search' + ':' + searchVal;
          // info("addToMulti",item);
          if (App.plantSelectorForm.multiselect.addToDatasource(searchVal, item)) {
            App.plantSelectorForm.multiselect.addToSelected(item);
            return true;
          }
          return false;
        };
        if (!addToMulti()) {
          window.setTimeout(addToMulti, 1000);
        }

        App.router.navigate("/plants/" + Utils.strEncodeURI(searchVal), true);

      } else {
        info("sorry, we can't search for that... try again?");
      }
    }
  }

  public clearSearch() {
    info("search.clear");// searchable:", this.searchable);
    this.searchable.forEach((i) => this.filtersClear(i));
    // this.filters.clear('common_name');
    // this.filters.clear('botanical_name');
    App.plantSelectorForm.multiselect.removeFromSelectedByPropName('Search');
    App.router.navigate("/plants", true);
  }

  public addEvents() {

    // [re] init the results panel offon click events 

    if ($("#plant_list_container").length && $("#plant-selector-listview").length) {

      // add click events to sort triggers

      if ($("#plant_list_sort_common").length) {
        //<span id="plant_list_sort_common" class="plant-list-sort-name active">Common</span> 
        $("#plant_list_sort_common").off("click").on("click", function (e) {
          // e.preventDefault();
          e.stopPropagation();
          // changed from buttons to radios
          // $(".plant-list-sort-name").removeClass("active");
          // $(this).addClass("active");
          // $('input:radio[name=plant-list-sort-name]').val(["common"]);
          $('input:radio[name=plant-list-sort-name]').removeAttr("checked");
          $("input:radio[name=plant-list-sort-name]").filter('[value=common]').attr('checked', 'checked');
          
          App.plants.sortByCommon();

          //$(".plant-list-common-name").addClass("sort-active");
          //$(".plant-list-botanical-name").removeClass("sort-active");
          $("#plant-selector-listview").removeClass("sort-name-botanical").addClass("sort-name-common");
        });
      }
      if ($("#plant_list_sort_botanical").length) {
        //<span id="plant_list_sort_botanical" class="plant-list-sort-name">Botanical</span>
        $("#plant_list_sort_botanical").off("click").on("click", function (e) {
          // e.preventDefault();
          e.stopPropagation();
          // changed from buttons to radios
          // $(".plant-list-sort-name").removeClass("active");
          // $(this).addClass("active");
          // $('input:radio[name=plant-list-sort-name]').val(["botanical"]);
          $('input:radio[name=plant-list-sort-name]').removeAttr("checked");
          $("input:radio[name=plant-list-sort-name]").filter('[value=botanical]').attr('checked', 'checked');

          App.plants.sortByBotanical();

          //$(".plant-list-common-name").removeClass("sort-active");
          //$(".plant-list-botanical-name").addClass("sort-active");
          $("#plant-selector-listview").removeClass("sort-name-common").addClass("sort-name-botanical");
        });
      }

      /*
          * <span id="plant_list_sort_up_down_text">A-Z</span>
          <a href="#sort-asc" id="plant_list_sort_asc" class="plant-list-sort-az active">up</a>
          <a href="#sort-desc" id="plant_list_sort_desc" class="plant-list-sort-az">down</a>
          */
      if ($("#plant_list_sort_up_down_text").length) {
        if ($("#plant_list_sort_asc").length) {
          $("#plant_list_sort_asc").off("click").on("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            $(".plant-list-sort-az").removeClass("active");
            App.plants.sortAsc();
            $(this).addClass("active");

            $("#plant_list_sort_up_down_text").text("A-Z");
          });
        }
        if ($("#plant_list_sort_desc").length) {
          $("#plant_list_sort_desc").off("click").on("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            $(".plant-list-sort-az").removeClass("active");
            App.plants.sortDesc();
            $(this).addClass("active");

            $("#plant_list_sort_up_down_text").text("Z-A");
          });
        }
      }


    } // END/ "#plant_list_container"

    // if ($(".action__plant-list-item").length) {
    //     $(".action__plant-list-item").off("click").on("click", function(e) {
    //         e.preventDefault();
    //         e.stopPropagation();
    //         info("clik");
    //     });
    // }

  } //end addEvents


} //end App.Plants
